import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: '[app-item-property-container]',
  templateUrl: './item-property-container.component.html',
  styleUrls: ['./item-property-container.component.scss'],
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: { 'class': 'flex flex-col flex-auto p-4 frosty bokeh' },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ItemPropertyContainerComponent implements OnInit {

  @Input()
  public headerTitle: string;

  @Input()
  public description: string;


  constructor(translate: TranslateService) {
   
   }

  ngOnInit(): void {
  }

}
